class menuMain {
  constructor(context) {
    context.querySelectorAll('[data-toggle-menu]').forEach(element => {
      element.addEventListener('click', (e) => {
        e.preventDefault();
        const body = context.querySelector('body');
        body.classList.toggle('menu-open');
        if (body.classList.contains('menu-open')) {
          body.classList.remove('search-open');
        }
        return false;
      });
    });
    
    context.querySelectorAll('[data-toggle-search]').forEach(element => {
      element.addEventListener('click', (e) => {
        e.preventDefault();
        document.querySelector('body').classList.add('menu-open');
        document.querySelector('body').classList.add('search-open');
        return false;
      });
    });
  }
};

export default menuMain;